import { render, staticRenderFns } from "./navs.vue?vue&type=template&id=1ce256f1&scoped=true&"
import script from "./navs.vue?vue&type=script&lang=js&"
export * from "./navs.vue?vue&type=script&lang=js&"
import style0 from "./navs.vue?vue&type=style&index=0&id=1ce256f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce256f1",
  null
  
)

export default component.exports